import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'
import {
    CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT,
    MEDICAL_CHECK_WITH_PRETREATMENT,
    MEDICAL_ASSESSMENT,
    CONFIRM_MEDICAL_ASSESSMENT
} from '../../../process/ui-definition/sales-order/in-shop-scan/task-name'

const CANNOT_BE_TREATED_REASON_LIST_WITH_PRETREATMENT = [
    { id: 'Anterior_crossbite_involving_too_many_anterior_teeth', value: 'Anterior crossbite involving too many anterior teeth' },
    { id: 'Class_III', value: 'Class III' },
    { id: 'Crowding_Spacing_higher_than_6_mm', value: 'Crowding/Spacing higher than 6 mm' },
    { id: 'Deep_bite_cannot_be_solved', value: 'Deep bite cannot be solved (ONLY when chief complaint)' },
    { id: 'Diastema_too_massive', value: 'Diastema too massive' },
    { id: 'Due_to_Tooth_Status', value: 'Due to Tooth Status (i.e. missing teeth, implants/bridges in anterior region)' },
    { id: 'Intrusion_Extrusion_not_possible', value: 'Intrusion/Extrusion not possible (ONLY if chief complaint)' },
    { id: 'Midline_discrepancy_cannot_be_solved', value: 'Midline discrepancy cannot be solved (ONLY when chief complaint)' },
    { id: 'other', value: 'Other (write reason in comment field)' },
    { id: 'Overjet_too_large', value: 'Overjet too large' },
    { id: 'parodontosis', value: 'Periodontitis' },
    { id: 'Posterior_open_bite', value: 'Posterior open bite' },
    { id: 'Pre_Treatment_necessary', value: 'Pre-Treatment necessary (i.e. periodontitis, caries)' },
    { id: 'Rotation_of_canines_too_massive', value: 'Rotation of canines too massive' },
    { id: 'Rotation_of_incisors_too_massive', value: 'Rotation of incisors too massive' },
    { id: 'tmj', value: 'TMJ disorder (CMD)' },
    { id: 'Unstable_bite', value: 'Unstable bite' },
]

const CANNOT_BE_TREATED_REASON_LIST_WITHOUT_PRETREATMENT = [
    { id: 'Anterior_crossbite_involving_too_many_anterior_teeth', value: 'Anterior crossbite involving too many anterior teeth' },
    { id: 'Class_III', value: 'Class III' },
    { id: 'Crowding_Spacing_higher_than_6_mm', value: 'Crowding/Spacing higher than 6 mm' },
    { id: 'Deep_bite_cannot_be_solved', value: 'Deep bite cannot be solved (ONLY when chief complaint)' },
    { id: 'Diastema_too_massive', value: 'Diastema too massive' },
    { id: 'Due_to_Tooth_Status', value: 'Due to Tooth Status (i.e. missing teeth, implants/bridges in anterior region)' },
    { id: 'Intrusion_Extrusion_not_possible', value: 'Intrusion/Extrusion not possible (ONLY if chief complaint)' },
    { id: 'Midline_discrepancy_cannot_be_solved', value: 'Midline discrepancy cannot be solved (ONLY when chief complaint)' },
    { id: 'other', value: 'Other (write reason in comment field)' },
    { id: 'Overjet_too_large', value: 'Overjet too large' },
    { id: 'Posterior_open_bite', value: 'Posterior open bite' },
    { id: 'Pre_Treatment_necessary', value: 'Pre-Treatment necessary (i.e. periodontitis, caries)' },
    { id: 'Rotation_of_canines_too_massive', value: 'Rotation of canines too massive' },
    { id: 'Rotation_of_incisors_too_massive', value: 'Rotation of incisors too massive' },
    { id: 'Unstable_bite', value: 'Unstable bite' },
]

export const getCannotBeTreatedReasonsList = (taskName) => {
    const taskList = [
        CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT,
        MEDICAL_CHECK_WITH_PRETREATMENT,
        MEDICAL_ASSESSMENT,
        CONFIRM_MEDICAL_ASSESSMENT
    ]
    const found = taskList.includes(taskName)

    return found ? CANNOT_BE_TREATED_REASON_LIST_WITH_PRETREATMENT : CANNOT_BE_TREATED_REASON_LIST_WITHOUT_PRETREATMENT
}

const CannotBeTreatedReasonWidget = ({ readOnly, context, changeProcessContext, saveProcessContext, taskName, validationMessageList }) => {
    if (!currentUserHasAccess(CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Cannot be treated reason">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList} />
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Reason">
                        <Select
                            name="cannotBeTreatedReason"
                            object={context}
                            valueList={getCannotBeTreatedReasonsList(taskName)}
                            addEmpty={true}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={6} />
            </Row>
        </ContentBox>
    )
}

CannotBeTreatedReasonWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    taskName: PropTypes.string.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default CannotBeTreatedReasonWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/CannotBeTreatedReasonWidget.js